// extracted by mini-css-extract-plugin
export default {"small":"only screen and (min-width: 576px)","color-grey-1":"#707070","colorGrey1":"#707070","breadcrumbs":"_3cEkE","breadcrumb":"_2GkxU","currentPage":"_1Rg-n"};